import { Router } from '@angular/router';
import { ClinicGroupFranchiseSsoInfo } from 'app/shared/clinics/models/clinic-group-franchise-sso-info.model';
import { ClinicReferrerPortalSetup } from 'app/shared/portal/models/clinic-referrer-portal-setup.model';
import { Identifier } from 'app/shared/storage/services/local-storage.service';
import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';

@Injectable()
export class NavigationHandlerService {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  handleNavigation(): void {
    this.navigate();
  }

  logout(): void {
    this.authService.logout();
    const ssoInfoJson = localStorage.getItem(Identifier.TYPE_SSO_INFO);
    if (ssoInfoJson) {
      const ssoInfo: ClinicGroupFranchiseSsoInfo = JSON.parse(ssoInfoJson);
      window.open(ssoInfo.returnUrl, '_self');
      return;
    }
    this.router.navigate(['landing']).then();
  }

  navigate(): void {
    const portalSetupJson = localStorage.getItem('portalSetup');
    if (portalSetupJson) {
      const portalSetup: ClinicReferrerPortalSetup = JSON.parse(portalSetupJson);
      if (portalSetup.showDashboard) {
        this.router.navigate([decodeURIComponent('/dashboard')]).then();
      } else if (portalSetup.showClients) {
        this.router.navigate([decodeURIComponent('/clients')]).then();
      } else {
        this.router.navigate([decodeURIComponent('/landing')]).then();
      }
    }
  }
}
